import { render } from "./DetailsModal.vue?vue&type=template&id=7392c4c6&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=7392c4c6&scoped=true&lang=css"
import "./DetailsModal.vue?vue&type=style&index=1&id=7392c4c6&lang=scss&scoped=true"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7392c4c6"]])

export default __exports__